import Button from '@mui/material/Button';
import Formsy from 'formsy-react';
import { Map } from 'immutable';
import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';

import MinimalSelectBox from '@sophocles/components/FormFields/MinimalSelectBox';
import MinimalTextBox from '@sophocles/components/FormFields/MinimalTextBox';

class StationInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      error: null,
      canSubmit: true,
      openStationInfo: null,
      errors: null,
      loading: false,
      value: 7,
    };
  }

  // closeDialog = () => this.setState({selectedStation:false});
  _setLoading = loading => this.setState({ loading });

  clearErrors = () => this.setState({ errors: null });

  _fetchData = (latitude, longitude, distance) => {
    this.setState({ data: null, error: null });
    const { fetchData, setLoading } = this.props;
    setLoading(true);
    fetchData(latitude, longitude, distance).then(res => {
      setLoading(false);
      if (_.has(res, 'error')) {
        this.setState({ error: res.error.errors });
      } else {
        this.setState({ data: res });
      }
    });
  };

  submit = values => this._fetchData(values.lat, values.long, values.dist);

  submitForm = () => this.form.submit();

  enableSaveButton = () => this.setState({ canSubmit: true });

  disableSaveButton = () => this.setState({ canSubmit: false });

  render() {
    const { user } = this.props;
    const { selectedStation, canSubmit, data, error, _fetchData, value, filter } = this.state;

    const defaultValue = Map({
      id: 0,
      center_latitude: 0,
      center_longitude: 0,
      last_refreshed: 0,
      map_abbreviation: 0,
    });

    return (
      <div style={{ padding: '8px' }}>
        <Formsy
          style={{ padding: '8px' }}
          ref={input => (this.form = input)}
          onSubmit={this.submit}
          onValid={this.enableSaveButton}
          onInvalid={this.disableSaveButton}
        >
          <div style={{ maxWidth: '300px' }}>
            <label style={{ margin: 0, fontWeight: 'bold' }}>Latitude</label>
            <MinimalTextBox
              type="number"
              name="lat"
              placeholder="Latitude"
              value={''}
              inputProps={{ min: 17.6, max: 71.31 }}
              validations={{
                isNumeric: true,
                isValid: (values, value) => (value >= 17.6 && value <= 71.31 ? true : 'Valid range 17.6 to 71.31'),
              }}
            />
          </div>
          <div style={{ maxWidth: '300px' }}>
            <label style={{ margin: 0, fontWeight: 'bold' }}>Longitude</label>
            <MinimalTextBox
              type="number"
              name="long"
              placeholder="Longitude"
              value={''}
              inputProps={{ min: -180, max: -64.1 }}
              validations={{
                isNumeric: true,
                isValid: (values, value) => (value >= -180 && value <= -64.1 ? true : 'Valid range -180 to -64.1'),
              }}
            />
          </div>
          <div style={{ maxWidth: '150px' }}>
            <label style={{ margin: 0, fontWeight: 'bold' }}>Distance</label>
            <MinimalSelectBox name="dist" value={7} style={{ display: 'inline_float' }}>
              <option value={1}>Distance: 1 km </option>
              <option value={3}>Distance: 3 km </option>
              <option value={5}>Distance: 5 km </option>
              <option value={7}>Distance: 7 km </option>
            </MinimalSelectBox>
          </div>
          <div style={{ marginTop: '7px' }}>
            <Button variant="contained" color="primary" disabled={!canSubmit} onClick={this.submitForm}>
              Submit
            </Button>
          </div>
        </Formsy>
        <div>{data && <StationReturn station={data} setLoading={this._setLoading} />}</div>
        <div>
          {error && <div style={{ color: 'red', fontSize: '1.5em', textDecoration: 'underline' }}>{error.error}</div>}
        </div>
      </div>
    );
  }
}
export default StationInformation;

class StationReturn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { station } = this.props;
    const color = station.get('html_color').toString();
    const peakColorDiv = (
      <div
        style={{
          width: '20px',
          height: '20px',
          backgroundColor: color,
          display: 'float',
          marginLeft: '4px',
        }}
      />
    );
    const dist = station.get('distance_to_station_km');
    const distanceInKm = dist.toFixed(1);
    const distanceInMiles = (dist * 0.62137).toFixed(1);
    const nearestStation = station.get('nearest_station', Map());
    const centerLat = nearestStation.get('center_latitude');
    const centerLong = nearestStation.get('center_longitude');
    const abbreviation = nearestStation.get('map_abbreviation');
    const url = nearestStation.get('noaa_url') ? (
      <Link href={nearestStation.get('noaa_url')} target="_blank">
        {abbreviation}
      </Link>
    ) : (
      abbreviation
    );
    const colorString = station.get('color_string');
    const colorValue = station.get('color_value');

    return (
      <div style={{ padding: '8px' }}>
        <div>Distance to station in miles: {distanceInMiles}</div>
        <div>Distance to station in kilometers: {distanceInKm}</div>
        <div>Radar station latitude: {centerLat}</div>
        <div>Radar station longitude: {centerLong}</div>
        <div>Abbreviation: {url}</div>
        <div>Color string: {colorString}</div>
        <div>Color value: {colorValue}</div>
        <div style={{ display: 'flex' }}>Peak Color: {peakColorDiv} </div>
      </div>
    );
  }
}
